import { useDisclosure, VStack } from '@chakra-ui/react';
import { type FC, useState } from 'react';

import { DeleteStudentInvitationModal } from '$/pages/StudentsPage/components/DeleteStudentInvitationModal';
import { EditStudentInvitationModal } from '$/pages/StudentsPage/components/EditStudentInvitationModal';
import { InvitationCard } from '$/pages/StudentsPage/components/InvitationCard';
import { type StudentInvitationRequest } from '$/services/usecases/invitation/mapper/invitation';
import { type SchoolClass } from '$/services/usecases/school/mapper/schoolClasses';

interface Props {
  studentInvitations: StudentInvitationRequest[];
  schoolClassOptions: SchoolClass[];
}

export const StudentInvitationCardList: FC<Props> = ({
  studentInvitations,
  schoolClassOptions,
}) => {
  const editModal = useDisclosure();
  const deleteModal = useDisclosure();

  const [selectedInvitation, setSelectedInvitation] =
    useState<StudentInvitationRequest | null>(null);

  const handleEdit = (invitation: StudentInvitationRequest) => {
    setSelectedInvitation(invitation);
    editModal.onOpen();
  };

  const handleDelete = (invitation: StudentInvitationRequest) => {
    setSelectedInvitation(invitation);
    deleteModal.onOpen();
  };

  return (
    <>
      <VStack w='full'>
        {studentInvitations.map((invitation) => (
          <InvitationCard
            key={invitation.id}
            studentInvitation={invitation}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        ))}
      </VStack>

      {selectedInvitation != null && (
        <>
          <EditStudentInvitationModal
            invitation={selectedInvitation}
            isOpen={editModal.isOpen}
            onClose={() => {
              editModal.onClose();
              setSelectedInvitation(null);
            }}
            schoolClassOptions={schoolClassOptions}
          />
          <DeleteStudentInvitationModal
            invitation={selectedInvitation}
            isOpen={deleteModal.isOpen}
            onClose={() => {
              deleteModal.onClose();
              setSelectedInvitation(null);
            }}
          />
        </>
      )}
    </>
  );
};
